<div class="tree-node" [class.highlight-zone]="isTarget()" cdkDropList [cdkDropListData]="items" [id]="listId"
    [cdkDropListConnectedTo]="connectedListIds" (cdkDropListDropped)="drop($event)"
    [cdkDropListEnterPredicate]="enterPredicate" (cdkDropListEntered)="onListEntered()"
    [cdkDropListSortingDisabled]="isDualPane && treeType === 'source'">

    <!-- Top Add Button (Empty list or no elements) -->
    @if (shouldShowAddHelperAtTop()) {
    <div style="padding: 0 10px; display:flex; gap: 5px;">
        <button class="add-element-btn mb-2" (click)="addLocalItem($event, 'element')">{{ getAddButtonLabel()
            }}</button>
        @if (isStatementParent()) {
        <button class="add-element-btn mb-2" (click)="addLocalItem($event, 'page')">+ Add Page</button>
        }
    </div>
    }

    @if (shouldShowRouteAddButton) {
    <div style="padding: 0 10px 10px; display:flex; flex-direction:column; gap: 5px; position: relative;">
        <button class="add-element-btn" type="button" (click)="toggleAddRouteDropdown($event)">+ Add Section</button>
        @if (showAddRouteDropdown) {
        <div class="route-dropdown">
            @for (route of routeDropdownOptions; track route.value) {
            <div class="route-option" (click)="selectRouteOption(route.value)">{{ route.label }}</div>
            }
        </div>
        }
    </div>
    }

    @for (item of items; track item.id; let i = $index) {
    <div>
        @if (treeType === 'source') {
        <div class="tree-item drag-ghost" [class.ghost-dragging]="draggingId === item.id && isHoveringTarget()">
            @if (hasVisibleChildren(item)) {
            }
            @if (item.tag) {
            <div class="item-tag" [title]="item.tag">{{item.tag.length > 10 ? (item.tag | slice:0:10) + '…' : item.tag}}</div>
            }
            @if (sidebarReorderMode) {
            <span class="item-content">{{ getSidebarReorderItemLabel(item) }}</span>
            } @else if (item.isUpdated) {
            <span class="item-content"
                [innerHTML]="(item.updatedText ?? item.name) | diff : getOriginalValue(item)"></span>
            } @else {
            <span class="item-content" [innerHTML]="(item.updatedText ?? item.name) | highlight: searchTerm"></span>
            }
        </div>
        }

        <div class="tree-item-container" cdkDrag [cdkDragData]="item" [cdkDragDisabled]="!canReorder"
            [class.source-ghost]="treeType === 'source' && draggingId === item.id"
            [class.has-menu-open]="activeMenuItemId === item.id"
            [class.route-transfer-item]="routeTransferMode"
            (cdkDragStarted)="onDragStarted(item)" (cdkDragEnded)="onDragEnded()">

            <div class="tree-item" [class.editing-active]="interactionService.editingItem() === item"
                [class.expanded]="item.expanded && (getVisibleChildren(item).length > 0 || canAddChildrenTo(item))"
                [class.sidebar-selected]="(sidebarReorderMode || showSelectButton) && selectedItemId === item.id"
                [class.deleted]="item.isDeleted" [class.new-item]="item.isNew" [class.moved-item]="item.isMoved"
                [class.modified-item]="item.isUpdated && !item.isNew" (click)="toggle(item)">
                @if (!routeTransferMode && (hasVisibleChildren(item) || canAddChildrenTo(item))) {
                <button class="toggle-btn" (click)="toggle(item); $event.stopPropagation()">
                    <i class="fa" [ngClass]="item.expanded ? 'fa-angle-down' : 'fa-angle-right'"></i>
                </button>
                }
                @if (canReorder) {
                <button class="drag-handle-btn" type="button" cdkDragHandle (click)="$event.stopPropagation()"
                    title="Drag to reorder">
                    <i class="fa fa-bars"></i>
                </button>
                }
                @if (showSelectButton && level === 0) {
                <button class="select-route-btn" type="button"
                    [class.active]="selectedItemId === item.id"
                    (click)="$event.stopPropagation(); itemClicked.emit(item)"
                    title="Select route">▶</button>
                }
                @if (item.tag) {
                <div class="item-tag-wrap">
                    @if (isEditable(item) && isEditingEnabled && !item.isDeleted) {
                    <button class="item-tag item-tag-btn" type="button"
                        (click)="openTagPicker(item, $event)"
                        [class.active]="activeTagPickerItemId === item.id"
                        [class.tag-changed]="item.originalTag !== undefined"
                        title="Change element type">{{item.tag}}</button>
                    @if (activeTagPickerItemId === item.id) {
                    <div class="tag-picker-popup" (click)="$event.stopPropagation()">
                        @for (type of editorElementTypes; track type) {
                        <button class="tag-picker-option" type="button"
                            [class.selected]="type === item.tag"
                            (click)="selectTagType(item, type, $event)">{{type}}</button>
                        }
                    </div>
                    }
                    } @else {
                    <div class="item-tag">{{item.tag}}</div>
                    }
                </div>
                }
                @if (routeTransferMode) {
                <div class="route-transfer-copy">
                    <span class="route-transfer-preview">{{ getRouteItemPreview(item) }}</span>
                </div>
                } @else if (sidebarReorderMode) {
                <span class="item-content sidebar-reorder-content">{{ getSidebarReorderItemLabel(item) }}</span>
                @if (canDuplicateItem(item) || canDelete(item)) {
                <div class="tree-actions">
                    <button class="action-icon icon-action-btn" type="button"
                        *ngIf="canDuplicateItem(item)"
                        [title]="item.level === TreeLevel.Route ? 'Duplicate route' : 'Duplicate component'"
                        (click)="duplicateItem(item, $event)">
                        <i class="fa fa-files-o"></i>
                    </button>
                    <button class="action-icon icon-action-btn" type="button"
                        *ngIf="canDelete(item)"
                        [title]="item.isDeleted ? 'Restore route' : 'Delete route'"
                        (click)="remove(item, $event)">
                        <i class="fa" [ngClass]="item.isDeleted ? 'fa-undo' : 'fa-trash'"></i>
                    </button>
                </div>
                }
                } @else if (isInlineEditing(item)) {
                <div class="inline-text-editor" (click)="$event.stopPropagation()">
                    @if (shouldShowInlineValueInput(item)) {
                    <textarea class="inline-row-textarea" appAutofocus [ngModel]="item.updatedText ?? item.name ?? ''"
                        (ngModelChange)="updateInlineText($event)" (blur)="saveInlineEdit()" rows="3"></textarea>
                    } @else {
                    <div class="inline-edit-note">This element has no inline text content. Use Advanced Settings for tag or properties.</div>
                    }
                </div>
                } @else if (item.isUpdated) {
                <span class="item-content editable-content" [class.can-inline-edit]="isTextEditable(item)"
                    [innerHTML]="(item.updatedText ?? item.name) | diff : getOriginalValue(item)"
                    (click)="beginTextEdit(item, $event)"></span>
                } @else {
                <span class="item-content editable-content" [class.can-inline-edit]="isTextEditable(item)"
                    [innerHTML]="(item.updatedText ?? item.name) | highlight: searchTerm"
                    (click)="beginTextEdit(item, $event)"></span>
                }

                <!-- Right Actions for Elements/Components/Routes -->
                @if (!routeTransferMode && !sidebarReorderMode && (shouldShowPropertiesIcon(item) || (isEditingEnabled && (canDelete(item) || isEditable(item))))) {
                <div class="tree-actions">
                    @if (pageHeights?.get(item.id); as heightInfo) {
                    <span class="page-height-chip" (click)="$event.stopPropagation()" [class.over]="heightInfo.over"
                        [title]="heightInfo.over
                            ? 'This page is ' + heightInfo.overBy + 'px taller than the /expand card and will be cut off'
                            : 'This page fits the /expand card'">
                        <span class="chip-meter">
                            <span class="chip-meter-fill" [style.width.%]="heightInfo.fillPercent"></span>
                        </span>
                        <span class="chip-value">{{ heightInfo.height }} / {{ heightInfo.budget }}px</span>
                        @if (heightInfo.over) {
                        <span class="chip-over"><i class="fa fa-exclamation-triangle"></i>
                            +{{ heightInfo.overBy }}px</span>
                        }
                    </span>
                    }
                    @if (shouldShowEditIcon(item) && !item.isDeleted) {
                    <button class="action-icon icon-action-btn" type="button" title="Advanced settings"
                        (click)="openAdvancedSettings(item, $event)">
                        <i class="fa fa-pencil-square-o"></i>
                    </button>
                    }
                    @if (canDelete(item)) {
                    <button class="action-icon icon-action-btn" type="button"
                        [title]="item.isDeleted ? 'Restore' : 'Delete'"
                        (click)="remove(item, $event)">
                        <i class="fa" [ngClass]="item.isDeleted ? 'fa-undo' : 'fa-trash'"></i>
                    </button>
                    }
                </div>
                }
            </div>

            @if (!routeTransferMode && !sidebarReorderMode && isAdvancedSettingsOpen(item)) {
            <div class="advanced-settings-popup" (click)="$event.stopPropagation()">
                <div class="advanced-settings-head">
                    <span>Advanced Settings</span>
                    <button class="inline-icon-btn" type="button" (click)="closeAdvancedSettings()" title="Close">
                        <i class="fa fa-times"></i>
                    </button>
                </div>

                <div class="advanced-settings-grid">
                    <div class="inline-editor-field inline-editor-field-wide">
                        <span class="inline-editor-label">Properties</span>
                        <div class="inline-properties-list">
                            @for (prop of inlineEditorProperties; track $index) {
                            <div class="inline-prop-row">
                                <input type="text" class="inline-prop-input" placeholder="Key" [(ngModel)]="prop.key"
                                    (ngModelChange)="markInlineMutation()">
                                <input type="text" class="inline-prop-input" placeholder="Value" [(ngModel)]="prop.value"
                                    (ngModelChange)="markInlineMutation()">
                                <button class="inline-icon-btn danger" type="button"
                                    (click)="removeInlineProperty($index, $event)" title="Remove">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                            }
                        </div>
                        <button class="inline-secondary-btn" type="button" (click)="addInlineProperty($event)">
                            <i class="fa fa-plus"></i>
                            <span>Add Property</span>
                        </button>
                    </div>
                </div>

                <div class="inline-editor-actions">
                    <button class="inline-secondary-btn" type="button"
                        (click)="cancelInlineEdit($event)">Cancel</button>
                    <button class="inline-primary-btn" type="button" (click)="saveInlineEdit($event)">Save</button>
                </div>
            </div>
            }

            <!-- Custom Pull Preview: Always collapsed (no children) -->
            <div *cdkDragPreview class="tree-item" style="box-shadow: 0 5px 15px rgba(0,0,0,0.15);">
                @if (hasVisibleChildren(item)) {
                <button class="toggle-btn">
                    <i class="fa fa-angle-right"></i>
                </button>
                }
                @if (item.tag) {
                <div class="item-tag">{{item.tag}}</div>
                }
                @if (sidebarReorderMode) {
                <span class="item-content">{{ getSidebarReorderItemLabel(item) }}</span>
                } @else if (item.isUpdated) {
                <span class="item-content"
                    [innerHTML]="(item.updatedText ?? item.name) | diff : getOriginalValue(item)"></span>
                } @else {
                <span class="item-content" [innerHTML]="(item.updatedText ?? item.name) | highlight: searchTerm"></span>
                }
            </div>

            <!-- Recursive children -->
            @if (!routeTransferMode && item.expanded && (getVisibleChildren(item).length > 0 || canAddChildrenTo(item))) {
            <div class="children-container">
                <app-tree [items]="getVisibleChildren(item)" [level]="level + 1" [treeType]="treeType"
                    [isEditingEnabled]="isEditingEnabled" [isReorderEnabled]="isReorderEnabled"
                    [searchTerm]="searchTerm" [parentItem]="item" [isDualPane]="isDualPane"
                    [routeTransferMode]="routeTransferMode" [sidebarReorderMode]="sidebarReorderMode"
                    [selectedItemId]="selectedItemId" [showSelectButton]="showSelectButton"
                    [pageHeights]="pageHeights"
                    (orderChanged)="orderChanged.emit()"
                    (nameChanged)="onChildNameChanged()"
                    (itemClicked)="itemClicked.emit($event)"></app-tree>
            </div>
            }

            <ng-template cdkDragPlaceholder>
                <div class="tree-item drag-placeholder" [class.source-shadow-placeholder]="treeType === 'source'">
                    @if (hasVisibleChildren(item)) {
                    <button class="toggle-btn"><i class="fa fa-angle-right"></i></button>
                    }
                    @if (item.tag) {
                    <div class="item-tag">{{item.tag}}</div>
                    }
                    @if (sidebarReorderMode) {
                    <span class="item-content">{{ getSidebarReorderItemLabel(item) }}</span>
                    } @else if (item.isUpdated) {
                    <span class="item-content"
                        [innerHTML]="(item.updatedText ?? item.name) | diff : getOriginalValue(item)"></span>
                    } @else {
                    <span class="item-content"
                        [innerHTML]="(item.updatedText ?? item.name) | highlight: searchTerm"></span>
                    }
                </div>
            </ng-template>
        </div>

        <!-- Add Button AFTER item (if it's the last element) -->
        @if (shouldShowAddHelperAfter(i)) {
        <div style="padding: 0 0px; display:flex; gap: 5px;">
            <button class="add-element-btn mt-1 mb-1" (click)="addLocalItem($event, 'element')">{{ getAddButtonLabel()
                }}</button>
            @if (isStatementParent()) {
            <button class="add-element-btn mt-1 mb-1" (click)="addLocalItem($event, 'page')">+ Add Page</button>
            }
        </div>
        }
    </div>
    }

</div>
